import React from 'react';
import { useTranslation } from 'react-i18next';
import OfferCardStat from '../../OfferStat';
import { PromoterOfferDto } from 'legacy/events/types';
import { currencyFormat } from 'legacy/common/utils/currency';

const OfferDetailsStats = ({ data }: { data: PromoterOfferDto }) => {
  const { t } = useTranslation(['events']);
  const { views, sales, revenue, earnings } = data.analytics;

  return (
    <div className="flex flex-col mt-6">
      <div className="flex flex-row ">
        <div className="flex-1">
          <OfferCardStat title={t('settings.promoterOffers.statistics.views')} description={views.toString()} />
        </div>
        <div className="flex-1">
          <OfferCardStat title={t('settings.promoterOffers.statistics.sales')} description={sales.toString()} />
        </div>
      </div>
      <div className="flex flex-row mt-4">
        <div className="flex-1">
          <OfferCardStat
            title={t('settings.promoterOffers.statistics.salesRevenue')}
            description={currencyFormat(revenue)}
          />
        </div>
        <div className="flex-1">
          <OfferCardStat
            title={t('settings.promoterOffers.statistics.promoterEarnings')}
            description={currencyFormat(earnings)}
          />
        </div>
      </div>
    </div>
  );
};

export default OfferDetailsStats;
